import React, {Component, ReactElement, ReactNode, RefObject} from 'react'

import NatBulletinBoardRepo from './repository/NatBulletinBoardRepo'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink, StyledLink} from '../../../styledComponents/adminPage/Links'
import {Messages} from '../../../Messages'
import {MESSAGE_TYPE, ROLE_FOR_ADMINISTRATOR} from '../../../CodeMaster'
import {StyledDiv, StyledLabel} from '../../../styledComponents/StyledTypeDefinitions'
import styled from 'styled-components'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import PPImageInputWithPreview, {ImageInformation} from '../../../components/shared/forms/PPImageInputWithPreview'
import {FlexStartRowFlexContainer, RowFlexContainer} from '../../../styledComponents/FlexComponents'
import PPInput from '../../../components/shared/forms/PPInput'
import PPNumericField from '../../../components/shared/forms/PPNumericField'
import {
    CommentFile,
    CommentImage,
    NatPostBulletinBoardThreadComment,
    NatPostBulletinBoardThreadCommentParams,
} from './repository/NatPostBulletinBoardThreadComment'
import {
    downloadDataUriSchemeOnMsSaveBlob,
    getFileExtension,
    getFileIconPath,
    openPdfPreviewWindow,
} from '../../common/util/Natutil'
import PPFileInput from '../../../components/shared/forms/PPFileInput'
import {isEdge, isIE} from 'react-device-detect'
import {Location} from 'react-router-dom'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'

const KEY_LOGIN_USER_FAMILY_NAME: string = 'loginUserAdminFamilyName'
const KEY_LOGIN_USER_FIRST_NAME: string = 'loginUserAdminFirstName'
const KEY_LOGIN_USER_ROLE_ID: string = 'loginUserRoleId'
const KEY_LOGIN_USER_ROLE_NAME: string = 'loginUserRoleName'

interface Props {
    threadId: number
    bulletinBoardRepo: NatBulletinBoardRepo
    eventEmitter: EventEmitterExAdmin
    location: Location

}

interface States {
    isLoadCompleted: boolean
    commentInfoComment: string
    commentInfoFiles: CommentFile[]
    commentInfoImages: ImageInformation[]
    publishFileName: string
    addFileButtonDisabled: boolean
    fileName: string
    fileData: string | ArrayBuffer | null
    fileSize: number
    fileInputDisabled: boolean

}


class NatAdminBulletinBoardThreadCommentRegisterPage extends Component<Props & AdminPagePropsSet, States> {

    threadCommentFile: RefObject<HTMLInputElement>

    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            isLoadCompleted: false,
            commentInfoComment: '',
            commentInfoFiles: [],
            commentInfoImages: [],
            publishFileName: '',
            fileName: '',
            fileData: '',
            fileSize: 0,
            addFileButtonDisabled: true,
            fileInputDisabled: false,
        }

        this.threadCommentFile = React.createRef()

        this.threadCommentRegisterClickButton = this.threadCommentRegisterClickButton.bind(this)
        this.clickCancelButton = this.clickCancelButton.bind(this)
        this.clickOkButton = this.clickOkButton.bind(this)
        this.backThreadPage = this.backThreadPage.bind(this)
        this.onChangeThreadComment = this.onChangeThreadComment.bind(this)
        this.onChangeImages = this.onChangeImages.bind(this)
        this.onChangeFile = this.onChangeFile.bind(this)
        this.onChangePublishFileName = this.onChangePublishFileName.bind(this)
        this.judgeRegisterButtonDisabled = this.judgeRegisterButtonDisabled.bind(this)
        this.changeThreadFileSortOrder = this.changeThreadFileSortOrder.bind(this)
        this.deleteThreadFile = this.deleteThreadFile.bind(this)
        this.validCommentInfoFileCount = this.validCommentInfoFileCount.bind(this)

    }

    async componentDidMount(): Promise<void> {
        this.setState({isLoadCompleted: true})
    }


    // 登録するボタン押下
    async threadCommentRegisterClickButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0012.errorLevel,
                message: Messages.IOPCC0012.toString('コメント'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.clickCancelButton,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.clickOkButton,
                    },
                ],
            },
        )
    }

    previewThreadCommentFile(dataUri: string): void {
        const data: string[] = dataUri.split(',')
        if (data[1]) {
            openPdfPreviewWindow(data[1])
        }
    }

    clickCancelButton(): void {
        this.props.eventEmitter.closeDialog()
    }

    async clickOkButton(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()
        try {

            const commentInfoImages: CommentImage[] = []
            if (this.state.commentInfoImages.length > 0) {
                this.state.commentInfoImages.map(
                    (image, index) => {
                        if (image.name && image.base64data && image.size) {
                            commentInfoImages.push({
                                fileName: image.name,
                                fileData: image.base64data,
                                fileSize: image.size,
                            })
                        }
                    },
                )
            }

            const commentInfoFiles: CommentFile[] = []
            if (this.state.commentInfoFiles) {
                this.state.commentInfoFiles.forEach((file, index) => {
                    if (file.deleteFlag === true) {
                        return
                    }
                    if (file.fileData) {
                        const fileData: string[] = String(file.fileData).split(',')
                        if (fileData[1]) {
                            commentInfoFiles.push({
                                sortOrder: file.sortOrder,
                                publishFileName: file.publishFileName,
                                fileName: file.fileName,
                                fileData: fileData[1],
                                fileSize: file.fileSize,
                                fileIndex: index,
                            })
                        }
                    }
                })
            }

            const postBulletinBoardThreadCommentParams: NatPostBulletinBoardThreadCommentParams = {
                threadId: this.props.threadId,
                comment: this.state.commentInfoComment,
                commentImage: commentInfoImages,
                commentFile: commentInfoFiles,
            }


            const postBulletinBoardThreadCommentResult: Nullable<NatPostBulletinBoardThreadComment> =
                await this.props.asyncCallFunction(
                    this.props.bulletinBoardRepo.postBulletinBoardThreadComment.bind(
                        this.props.bulletinBoardRepo, postBulletinBoardThreadCommentParams),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0001.toString('コメント')},
                )
            if (postBulletinBoardThreadCommentResult &&
                postBulletinBoardThreadCommentResult.details &&
                postBulletinBoardThreadCommentResult.requestError === null
            ) {
                this.props.navigate(`/admin/bulletinBoardThread/${this.props.threadId}/${postBulletinBoardThreadCommentResult.details.commentId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0007.toString('コメント'),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }

    }

    backThreadPage(): void {
        this.props.navigate(
            `/admin/bulletinBoardThread/${this.props.threadId}`,
        )
    }

    onChangeThreadComment(value: string): void {
        this.setState({commentInfoComment: value})
    }

    onChangeImages(images: ImageInformation[]): void {
        this.setState({commentInfoImages: images})
    }

    onChangePublishFileName(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.value && this.state.fileName) {
            this.setState({addFileButtonDisabled: false})
        } else {
            this.setState({addFileButtonDisabled: true})
        }
        this.setState({publishFileName: event.target.value})
    }

    validCommentInfoFileCount(): number {
        const commentInfoFiles = this.state.commentInfoFiles
        const validCommentInfoFileCount = commentInfoFiles.filter(file => file.deleteFlag === false).length
        return validCommentInfoFileCount
    }

    addThreadCommentFile(): void {
        const threadCommentFileList = this.state.commentInfoFiles
        const validThreadCommentFileList = threadCommentFileList.filter(file => file.deleteFlag === false)
        const threadFile: CommentFile = {
            ['sortOrder']: validThreadCommentFileList.length + 1,
            ['fileName']: this.state.fileName,
            ['fileSize']: this.state.fileSize,
            ['fileData']: this.state.fileData,
            ['publishFileName']: this.state.publishFileName,
            ['deleteFlag']: false,
        }
        threadCommentFileList.push(threadFile)
        this.setState({
            fileName: '',
            fileSize: 0,
            fileData: '',
            publishFileName: '',
            addFileButtonDisabled: true,
            commentInfoFiles: threadCommentFileList,
            fileInputDisabled: (validThreadCommentFileList.length + 1 >= 3),
        })
        // 追加したタイミングで選択したファイルをクリア
        if (this.threadCommentFile.current && this.threadCommentFile.current.value) {
            this.threadCommentFile.current.value = ''
        }
    }

    onChangeFile(event: React.ChangeEvent<HTMLInputElement>): void {
        // ファイル情報取得
        if (event.target.files && event.target.files[0] && event.target.files[0].name) {
            if (this.state.publishFileName) {
                this.setState({addFileButtonDisabled: false})
            } else {
                this.setState({addFileButtonDisabled: true})
            }
            this.setState({
                fileName: event.target.files[0].name,
                fileSize: event.target.files[0].size,
            })
            const reader: FileReader = new FileReader()
            reader.onload = () => {
                this.setState({fileData: reader.result})
            }
            reader.readAsDataURL(event.target.files[0])
        } else {
            this.setState({
                fileName: '',
                fileData: '',
                fileSize: 0,
                addFileButtonDisabled: true,
            })
        }
    }

    changeThreadFileSortOrder(event: React.ChangeEvent<HTMLInputElement>): void {
        const threadInfoFiles = this.state.commentInfoFiles
        threadInfoFiles[Number(event.target.name)].sortOrder = Number(event.target.value)
        this.setState({commentInfoFiles: threadInfoFiles})
    }

    deleteThreadFile(index: number): void {
        const threadInfoFiles = this.state.commentInfoFiles
        threadInfoFiles[index].deleteFlag = true
        threadInfoFiles[index].fileData = null
        const addFileCount = threadInfoFiles.filter(file => file.deleteFlag === false)
        this.setState({
            commentInfoFiles: threadInfoFiles,
            fileInputDisabled: (addFileCount.length >= 3),
        })
    }

    judgeRegisterButtonDisabled(): boolean {
        return !(this.state.commentInfoComment)
    }

    getFileLink(commentFile: CommentFile): ReactElement {
        switch (getFileExtension(commentFile.fileName).toUpperCase()) {
            case 'PDF':
                return (
                    <a href="javascript:void(0)" target={'_blank'}
                       onClick={(event: React.MouseEvent<HTMLElement>) => {
                           event.preventDefault()
                           this.previewThreadCommentFile(commentFile.fileData as string)
                       }}>
                        <img
                            src={getFileIconPath(getFileExtension(commentFile.fileName))}
                            alt={commentFile.fileName}/>
                    </a>
                )
                break

            default:
                if (isIE || isEdge) {
                    return (
                        <a href="javascript:void(0)" onClick=
                            {() => downloadDataUriSchemeOnMsSaveBlob(String(commentFile.fileData),
                                `${commentFile.publishFileName}.${getFileExtension(commentFile.fileName)}`)}>
                            <img src={getFileIconPath(getFileExtension(commentFile.fileName))}
                                 alt={commentFile.fileName}/>
                        </a>
                    )
                } else {
                    return (
                        <a href={String(commentFile.fileData)}
                           download={`${commentFile.publishFileName}.${getFileExtension(commentFile.fileName)}`}>
                            <img src={getFileIconPath(getFileExtension(commentFile.fileName))}
                                 alt={commentFile.fileName}/>
                        </a>
                    )
                }
                break
        }
    }

    renderPageFooterArea(): ReactNode {
        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={this.judgeRegisterButtonDisabled()}
                        onClick={this.threadCommentRegisterClickButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={this.backThreadPage}
                    >
                        スレッド詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    renderThreadCommentFormTable(): ReactNode {

        const assocFlag: boolean =
            SessionStorageHelper.getStringItemOrNull(KEY_LOGIN_USER_ROLE_ID) === ROLE_FOR_ADMINISTRATOR.ASSOC.value
        const loginUserRoleName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_ROLE_NAME, '')
        const loginUserAdminFamilyName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_FAMILY_NAME, '')
        const loginUserAdminFirstName: string =
            SessionStorageHelper.getStringItemWithDefault(KEY_LOGIN_USER_FIRST_NAME, '')

        return (
            <Table>
                <StyledTableCaption>コメント情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName>投稿者</TableRowName>
                        <TableCell>
                            {`${loginUserAdminFamilyName} ${loginUserAdminFirstName}`}
                            {!assocFlag &&
                                `　${Messages.INTFA0028.toString(loginUserRoleName)}`
                            }
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>コメント内容</TableRowName>
                        <TableCell>
                            <PPHtmlEditor
                                onEditorChange={this.onChangeThreadComment}
                                eventKeys={['comment']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName>画像</TableRowName>
                        <TableCell>
                            <PPImageInputWithPreview
                                images={this.state.commentInfoImages}
                                maxCount={4}
                                maxFileSizeBytesPerFile={5 * 1024 * 1024}
                                maxFileSizeBytesPerFileMessage={
                                    'アップロードファイルの上限サイズは1ファイルあたり5MBまでです'
                                }
                                helperText={<div style={{color: 'red'}}>
                                    ※5MBまで
                                </div>}
                                eventEmitter={this.props.eventEmitter}
                                inputProps={{
                                    accept: 'image/jpeg,image/png,image/gif',
                                }}
                                eventKeys={['commentImage']}
                                onChange={this.onChangeImages}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName
                            {...{
                                rowSpan: this.validCommentInfoFileCount() !== 0 ?
                                    this.validCommentInfoFileCount() + 1 : 1,
                            }}
                        >ファイル</TableRowName>
                        <TableCell colSpan={4}>
                            <FlexStartRowFlexContainer>
                                <DocumentNameWrapper>
                                    <TableCellLabelNoLeftPadding>ファイル名</TableCellLabelNoLeftPadding>
                                    <PPTextField
                                        InputProps={{
                                            inputProps: {
                                                id: 'onChangePublishFileName',
                                                maxLength: 50,
                                            },
                                        }}
                                        required
                                        fullWidth
                                        onChange={this.onChangePublishFileName}
                                        eventKeys={['publishMaterialInfo']}
                                        value={this.state.publishFileName}
                                        eventEmitter={this.props.eventEmitter}
                                        disabled={this.state.fileInputDisabled}
                                    />
                                </DocumentNameWrapper>
                                <DocumentWrapper>
                                    <DocumentFormWrapper>
                                        <PPFileInput
                                            InputProps={{
                                                inputProps: {
                                                    id: 'messageFile',
                                                    name: 'messageFile',
                                                },
                                            }}
                                            fullWidth
                                            inputRef={this.threadCommentFile}
                                            onChange={this.onChangeFile}
                                            fileName={this.state.fileName}
                                            eventKeys={['threadCommentFile']}
                                            eventEmitter={this.props.eventEmitter}
                                            disabled={this.state.fileInputDisabled}
                                        />
                                    </DocumentFormWrapper>
                                    <div style={{color: 'red', flex: '1 0 auto'}}>
                                        ※5MBまで<br/>※特定のファイル形式(.docx/.xlsx/.pptx/.pdf)以外は、<br/>{'　'}アップロード出来ません。
                                    </div>
                                </DocumentWrapper>
                                <DocumentAddButtonWrapper>
                                    <AdminPrimaryButton
                                        onClick={this.addThreadCommentFile.bind(this)}
                                        disabled={this.state.addFileButtonDisabled || this.state.fileInputDisabled}
                                    >ファイルを追加
                                    </AdminPrimaryButton>
                                </DocumentAddButtonWrapper>
                            </FlexStartRowFlexContainer>
                        </TableCell>
                    </TableRow>
                    {this.renderFileArea()}
                </TableBody>
            </Table>
        )
    }

    renderFileArea(): ReactNode {
        return (
            <> {this.state.commentInfoFiles.map((threadCommentFile, index) => (
                (threadCommentFile.deleteFlag === false) ?
                    <TableRow key={index}>
                        <TableCell colSpan={3}>
                            <RowFlexContainer>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        {this.getFileLink(threadCommentFile)}
                                    </TableCellLabelNoLeftPadding>
                                    <PPInput
                                        type="label"
                                        value={threadCommentFile.publishFileName}
                                        eventKeys={[`commentFile[${index}].publishFileName`]}
                                        eventEmitter={this.props.eventEmitter}
                                    />
                                </AlreadyDocumentWrapper>
                                <TableCellLabelNoLeftPadding>
                                    並び順
                                </TableCellLabelNoLeftPadding>
                                <OrderWrapper>
                                    <DocumentFormWrapper>
                                        <PPNumericField
                                            InputProps={{
                                                inputProps: {
                                                    min: 1,
                                                    max: 999,
                                                },
                                            }}
                                            fullWidth
                                            name={String(index)}
                                            onChange={this.changeThreadFileSortOrder.bind(this)}
                                            value={threadCommentFile.sortOrder}
                                            eventKeys={[`commentFile[${index}].sortOrder`]}
                                            eventEmitter={this.props.eventEmitter}
                                        />
                                    </DocumentFormWrapper>
                                </OrderWrapper>
                                <AlreadyDocumentWrapper>
                                    <TableCellLabelNoLeftPadding>
                                        <StyledLink onClick={() => this.deleteThreadFile(index)}>
                                            削除
                                        </StyledLink>
                                    </TableCellLabelNoLeftPadding>
                                </AlreadyDocumentWrapper>
                            </RowFlexContainer>
                        </TableCell>
                    </TableRow>
                    : null
            ))}
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderThreadCommentFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }

}

const DocumentNameWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
  padding-right: 15px;
`

const TableCellLabelNoLeftPadding: StyledLabel = styled.label`
  padding: 0 10px 0 0;
`


const DocumentWrapper = styled(DocumentNameWrapper)`
  display: flex;
  flex: 1 0 auto;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-right: 15px;
  max-width: 40%;
`

const DocumentFormWrapper: StyledDiv = styled.div`
  flex: 1 0 auto;
  width: 100%;
`

const DocumentAddButtonWrapper: StyledDiv = styled.div`
  flex: 0 0 auto;
`

const AlreadyDocumentWrapper = styled(DocumentNameWrapper)`
  flex: 1 1 0%;
  align-items: center;
`

const OrderWrapper = styled(AlreadyDocumentWrapper)`
  max-width: 10%;
`


export default createAdminPage(NatAdminBulletinBoardThreadCommentRegisterPage)

